import React from 'react';
import './styles/About.css'; // Optional: Create this CSS file for styling

function About() {
    return (
        <main className="about">
            <section className="about__intro">
                <h1 className="about__title">About Us</h1>

                <p className="about__paragraph">
                    Our team explores human collaboration with artificial agents in complex, non-routine analytical
                    tasks. We focus on how different levels of AI embodiment—from basic computer agents to advanced
                    humanoid robots—affect team dynamics, decision-making, and communication. Our research seeks to
                    answer key questions about human-agent interaction, such as:
                </p>

                <ul className="about__questions">
                    <li>
                        How do artificial agents influence team performance in problem-solving tasks?
                    </li>
                    <li>
                        How does AI embodiment impact communication and collaboration in mixed human-agent teams?
                    </li>
                    <li>
                        What are the cognitive and social processes that drive successful teamwork with AI?
                    </li>
                    <li>
                        How can artificial agents be designed to better complement human efforts in high-stakes,
                        analytical tasks?
                    </li>
                </ul>

                <p className="about__ending">
                    To tackle these questions, we use a multidisciplinary approach, drawing from fields such as
                    computational linguistics, cognitive science, economics, and human-computer interaction. Our
                    research methods include experiments, linguistic analysis, and performance assessments in real-world
                    scenarios like escape room challenges.
                </p>

                <p>
                    The team is led by Caterina Giannetti, with key contributions from experts across the University of
                    Pisa and affiliated institutions.
                </p>

                <div className="about__logos">
                    <img src={`${process.env.PUBLIC_URL}/images/centro_piaggio.png`} alt="Centro Piaggio Logo" className="about__logo"/>
                    <img src={`${process.env.PUBLIC_URL}/images/MUR-logo.png`} alt="Ministero università e ricerca Logo" className="about__logo"/>
                    <img src={`${process.env.PUBLIC_URL}/images/CNRimage.png`} alt="CNR Logo" className="about__logo"/>
                </div>

            </section>
        </main>
    );
}

export default About;